import React, { useState, useEffect } from 'react'
import Col from '../../UIcomponent/Column'
import './MiniWeekly.scss'
import DateTime from '../../Utility/Method/DateTime'
import { theme } from '../../Utility/Theme'
const MiniWeekly = (props) => {
    const { calendar, available } = props
    let step = props.duration || 0.5;
    let row = props.row || 6
    const [week, setWeek] = useState([])
    let allDay =
        [
            {
                Start: 0,
                End: step,
                startHour: 0,
                startMin: 0,
                endHour: Math.floor(step),
                endMin: step % 1 !== 0 ? 30 : 0,
                isAvailable: false,
            }
        ];

    for (let i = 1; i < 7 * (24 / step); i++) {
        allDay.push({
            Start: allDay[i - 1].End,
            End: allDay[i - 1].End + step,
            startHour: allDay[i - 1].End < 24 ? Math.floor(allDay[i - 1].End) : Math.floor(allDay[i - 1].End) % 24,
            startMin: (allDay[i - 1].End) % 1 !== 0 ? 30 : 0,
            endHour: allDay[i - 1].End < 24 ? Math.floor(allDay[i - 1].End + step) : Math.floor(allDay[i - 1].End + step) % 24,
            endMin: (allDay[i - 1].End + step) % 1 !== 0 ? 30 : 0,
            isAvailable: false
        })
    };
    available.map(avai => {
        allDay.forEach((day) => {
            if ((day.Start <= avai.Start && day.End > avai.Start) || (day.End <= avai.End && day.Start > avai.Start)) {
                return day.isAvailable = true
            }

        }
        )
    })
    let Week = []
    let WeekDay = ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri']
    var i, j, chunk = 24 / step;
    let weekGenerate = (callback) => {
        for (i = 0, j = allDay.length; i < j; i += chunk) {
            Week.push({
                day: WeekDay[i / chunk],
                times: allDay.slice(i, i + chunk)
            })
        }
    }
    weekGenerate()
    // console.log('Week Day', Week);

    useEffect(() => {
        let weekInterval = () => setInterval(setWeek(Week), 0)
        weekInterval()
        return (() => {
            clearInterval(weekInterval)
        })
    }, [])
    return (
        <Col
            className='c__MiniWeekly'
            xl={24} lg={24} md={24} sm={24} xs={24}
            style={{
                height: props.size * (row + 1) + 'px',
                // overflow: MiniWeekly ? 'hidden' : calendar ? 'auto' : 'hidden'
            }}
        >
            <Col
                xl={4} lg={4} md={4} sm={4} xs={4}
                className='c__MiniWeekly__Hours'
            >
                <Col
                    className='o__MiniWeekly__Hours'
                >
                    {Week[0].times.map(hours => {
                        return (
                            <Col
                                style={{
                                    height: `${props.size}px`
                                }}
                            >{
                                    calendar ?
                                        (hours.startHour < 10 ? '0' + hours.startHour : hours.startHour) + ':' + (hours.startMin === 0 ? '00' : hours.startMin) + ' - ' + (hours.endHour < 10 ? '0' + hours.endHour : hours.endHour) + ':' + (hours.endMin === 0 ? '00' : hours.endMin)
                                        : (hours.startHour < 10 ? '0' + hours.startHour : hours.startHour) + ' - ' + (hours.endHour < 10 ? '0' + hours.endHour : hours.endHour)
                                }</Col>
                        )
                    })}
                </Col>

            </Col>
            <Col
                xl={21} lg={21} md={21} sm={21} xs={21}
                className='c__MiniWeekly__Day'
            >

                {Week.map(day => {
                    return (
                        <Col
                            xl={24 / 7} lg={24 / 7} md={24 / 7} sm={24 / 7} xs={24 / 7}
                            className='o__MiniWeekly__Day__Column' >
                            <Col
                                className='o__MiniWeekly__Day__Title'
                                style={{
                                    // ...props.titleStyle,
                                    height: `${props.size}px`,
                                    // marignTop: `-${props.size}px`
                                }}
                            >
                                {DateTime.getDayShortStr(day.day)[`${props.lang}`]}
                            </Col>
                            {
                                day.times.map(time => {
                                    return (
                                        <Col
                                            className='o__MiniWeekly__Day__Status'
                                            // height='auto'
                                            style={{
                                                ...props.dayStyle,
                                                backgroundColor: time.isAvailable ? theme.calendarGreen : 'white',
                                                height: `${props.size}px`
                                            }}
                                        >
                                        </Col>
                                    )
                                })
                            }
                        </Col>)

                })}
            </Col>

        </Col>
    )
}
export default MiniWeekly
